import React, { Component } from "react";
import {
  Button,
  Table,
  Alert,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import Select from 'react-select';
import * as permissionRoleConstant from './constants'
import * as permissionRoleAction from './actions'
import { customSelectStyles } from '../../lib/common';
import { storedb } from '../client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import { confirmAlert } from 'react-confirm-alert';

class PermissionRole extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      StoreId: dbContext.getStoreId(),
      item: {},
      listRole: [],
      permissionResult: [],
      permissionRoleResult: [],
      keyword: '',
      selectedOption: null,
      RoleId: 0,
      formError: []
    };
  }
  handleSearchChange = (e, name) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  keyPress = (e) => {
    if(e.keyCode == 13){
       this.featchDetail()
    }
  }
  handleRoleChange = selectedOption => {
    this.setState({ selectedOption });
    this.setState({ RoleId: selectedOption.value }, () => {
      this.featchDetail();
    });
  };
  featchDetail = () => {
    const { permissionRoleDetailRequest } = this.props
    var requestData = {
      keyword: this.state.keyword,
      StoreId: this.state.StoreId,
      RoleId: this.state.RoleId
    }
    return permissionRoleDetailRequest(requestData);
  }
  fetchListRole = () => {
    const { permissionRoleListRequest } = this.props
    var requestData = {
      stores_id: this.state.StoreId,
      keyword: this.state.keyword,
      status: this.state.TrangThaiId,
      page: 1,
      per_page: 200
    };
    return permissionRoleListRequest(requestData);
  }
  filterListPermission = (event) => {

    var updatedList = this.props.permissionRole.resultPermissionRole;
    updatedList = updatedList.filter(function (item) {
      return item.Name.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
    });
    this.setState({ permissionRoleResult: updatedList })
  }
  UpdatePermissionRole = (res, element) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.RoleId && this.state.RoleId > 0) {
      var requestData = {
        StoreId: this.state.StoreId,
        RoleId: this.state.RoleId || 0,
        PermissionIds: (res.PermissionId ? [res.PermissionId] : []),
        PermissionRoleIds: (res.PermissionRoleId ? [res.PermissionRoleId] : [])
      }
      this.props.permissionRoleUpdateRequest(requestData);
    } else {
      formError.RoleId = "Bạn chưa chọn quyền";
    }
    this.setState({ formError: formError });
  }
  UpdateAll = (res, flag) => {
    var formError = this.state.formError;
    formError = [];
    if (this.state.RoleId && this.state.RoleId > 0) {
      if (res && res.length > 0) {
        var requestData = {
          StoreId: this.state.StoreId,
          RoleId: this.state.RoleId || 0,
          PermissionIds: (flag == "add" ? res.map(function (item) { return item.PermissionId }) : []),
          PermissionRoleIds: (flag == "remove" ? res.map(function (item) { return item.PermissionRoleId }) : [])
        }
        this.props.permissionRoleUpdateRequest(requestData);
      }
    } else {
      formError.RoleId = "Bạn chưa chọn nhóm";
    }
    this.setState({ formError: formError });
  }
  processUpdateAllClick = (res, flag) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>THÔNG BÁO?</h1>
            <p>Bạn chắc chắn cập nhật tất cả dữ liệu này không?
            </p>
            <button className="text-danger" onClick={() => {
              this.UpdateAll(res, flag)
              onClose()
            }}>Đồng ý</button>
            <button onClick={onClose}>Hủy bỏ</button>
          </div>
        )
      }
    });
  }
  componentDidMount() {
    this.fetchListRole();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.permissionRole.type == permissionRoleConstant.PERMISSION_ROLE_LIST_SUCCESS) {
      let { list } = nextProps.permissionRole;
      this.setState({
        list: this.BuildSelectOption(list)
      });
    } else if (nextProps.permissionRole.type == permissionRoleConstant.PERMISSION_ROLE_UPDATE_SUCCESS) {
      this.featchDetail();
    } else if (nextProps.permissionRole.type == permissionRoleConstant.PERMISSION_ROLE_DETAIL_SUCCESS) {
      let { permissionResult, permissionRoleResult } = nextProps.permissionRole;
      this.setState({ permissionResult, permissionRoleResult })
    }
  }
  BuildSelectOption(list) {
    var options = [];
    if (list && list.length > 0) {
      list.map((item) => { options.push({ value: item.RoleId, label: item.Name }) }
      );
    }
    return options;
  }
  render() {
    const { selectedOption, list, permissionResult, permissionRoleResult } = this.state;
    const {
      handleSubmit,
      permissionRole: {
        listRequesting,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div className="mb-3 border">
            <Select
              styles={customSelectStyles}
              placeholder="Chọn nhóm người dùng"
              value={selectedOption}
              onChange={this.handleRoleChange}
              options={list}
            />
            <em className="error invalid-feedback">{this.state.formError.RoleId}</em>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 row">
              <div className="col-sm-6">
                <Alert color="primary">Danh sách quyền chưa được thêm vào nhóm</Alert>
                <InputGroup>
                  <Input placeholder="Tên quyền" 
                    onChange={(e) => this.handleSearchChange(e, "keyword")} 
                    onKeyDown={e => this.keyPress(e)}
                    />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" onClick={handleSubmit(this.featchDetail)}>
                      <i className="fa fa-search"></i> Tìm kiếm
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" className="text-left">Quyền sử dụng</th>
                      <th scope="col" width="50" className="text-left" >
                        <ButtonExt
                          btnClass="text-primary"
                          iconClass="fa-arrow-right fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(permissionResult, "add")}
                          permission={BtnPermissions.PermissionRole.ADD_OR_UPDATE} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionResult && !!permissionResult.length && (
                      permissionResult.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-left">{res.Name}</td>
                          <td className="text-left">
                            <ButtonExt
                              btnClass="text-primary"
                              iconClass="fa-arrow-right fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdatePermissionRole(res)}
                              permission={BtnPermissions.PermissionRole.ADD_OR_UPDATE} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
              <div className="col-sm-6">
                <Alert color="success">Danh sách quyền đã được thêm vào nhóm</Alert>
                <InputGroup>
                  <Input placeholder="Tên quyền" onChange={this.filterListPermission} />
                  <InputGroupAddon addonType="append" style={{ zIndex: 0 }}>
                    <Button color="success" >
                      <i className="fa fa-search"></i> Tìm kiếm
                      </Button>
                  </InputGroupAddon>
                </InputGroup>
                <Table hover responsive className="table-outline mt-2 d-sm-table table-sm">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">
                        <ButtonExt
                          btnClass="text-danger"
                          iconClass="fa-arrow-left fa-lg"
                          btnType={BtnType.ButtonLink}
                          btnClick={() => this.processUpdateAllClick(permissionRoleResult, "remove")}
                          permission={BtnPermissions.PermissionRole.ADD_OR_UPDATE} />
                      </th>
                      <th scope="col" className="text-left">Quyền sử dụng</th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissionRoleResult && !!permissionRoleResult.length && (
                      permissionRoleResult.map((res, idx) => (
                        <tr key={idx + 1}>
                          <td className="text-center">
                            <ButtonExt
                              btnClass="text-danger"
                              iconClass="fa-arrow-left fa-lg"
                              btnType={BtnType.ButtonLink}
                              btnClick={() => this.UpdatePermissionRole(res)}
                              permission={BtnPermissions.PermissionRole.ADD_OR_UPDATE} />
                          </td>
                          <td className="text-left">{res.Name}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  permissionRole: state.permissionRole,
  client: state.client,
})
const connected = connect(mapStateToProps, {
  permissionRoleListRequest: permissionRoleAction.permissionRoleListRequest,
  permissionRoleUpdateRequest: permissionRoleAction.permissionRoleUpdateRequest,
  permissionRoleDetailRequest: permissionRoleAction.permissionRoleDetailRequest,
})(PermissionRole)
const formed = reduxForm({
  form: 'permissionRole',
})(connected)
export default formed;



// WEBPACK FOOTER //
// ./src/views/PermissionRole/PermissionRole.js